module.exports = __webpack_public_path__ + "img/logo_navbar.2e36d74f.png";